import PageModeDropdown, { getPageModeLabel } from "components/dropdowns/reactselect/PageModeDropdown";
import { FormSection, RenderEditOptions } from "components/MainSectionTemplate/types";
import OptionalCodeAreaInput, { OptionalCodeAreaDetails } from "components/ValidatedFields/OptionalCodeAreaInput";
import React from "react";
import { getUpdateInstruction, WebformFormState } from "./model";
import CopyToClipboard from "components/Atoms/CopyToClipboard";

export const stylingSection = (
  embedCode: string,
  webformFormState: WebformFormState,
): FormSection => ({
  key: "styling",
  title: RESX.PersonalSettings.Styling,
  type: "collapsable",
  fields: [{
    key: "pageMode",
    label: "Page mode",
    render: () => <>{getPageModeLabel(webformFormState.pageMode)}</>,
    inPageEdit: {
      render: ({ value, onChange, cancel }) => <PageModeDropdown
        options={[]}
        value={value}
        onChange={(currency) => {
          onChange(currency, true);
        }}
        onEsc={() => cancel()}
        config={{
          focusOnMount: true,
          openMenuOnFocus: true,
        }}
      />,
      fullWidth: true,
      type: "custom",
      initialValue: webformFormState.pageMode,
      submitChange: async (pageMode: server.dto.BookingRequestPageModes) => window.CoreApi.WebformConfiguration.Update({
        ...getUpdateInstruction(webformFormState),
        pageMode,
      }),
    },
  }, {
    key: "iFrameCode",
    label: RESX.Webform.IFrameCode,
    hidden: webformFormState.pageMode !== "iFrame",
    render: () => <CopyToClipboard value={embedCode} />
  }, {
    key: "customCss",
    label: RESX.Webform.CustomizeStyling,
    sublabel: RESX.Webform.CssStyleSheet,
    isEmpty: !webformFormState.customCss,
    render: () => <OptionalCodeAreaDetails rows={10}>{webformFormState.customCss}</OptionalCodeAreaDetails>,
    inPageEdit: {
      render: ({ value, onChange, submit, cancel }: RenderEditOptions<string>) => <OptionalCodeAreaInput
        focusOnMount
        rows={10}
        maxLength={serverReference.constants.bookingRequest.maxCustomCssLength}
        value={value}
        onChange={(v) => { onChange(v); }}
        onCtrlEnter={() => submit()}
        onEsc={() => cancel()}
      />,
      fullWidth: true,
      type: "confirmOrCancelButton",
      initialValue: webformFormState.customCss,
      submitChange: async (customCss: string) => window.CoreApi.WebformConfiguration.Update({
        ...getUpdateInstruction(webformFormState),
        customCss: customCss,
      }),
    },
  }]
});